<template>
  <div class="wrapper-x-40">
    <div class="order-header font-bold text-xl mb-4">
      {{
                $t("admin.views.orders.detail_title", {
                    id: order.order_id,
                    date: order.date
                })
            }}
    </div>

    <div class="flex">
      <div class="w-1/2">
        <div class="customer">
          <div class="font-bold mb-4">
            {{ $t("admin.views.orders.customer") }}
          </div>
          <div class="text-sm mb-8">
            <div>
              {{ $t("admin.views.orders.name") }}:
              <span>{{ order.name }}</span>
            </div>
            <div>
              {{ $t("admin.views.orders.phone") }}:
              <span>{{ order.phone }}</span>
            </div>
            <div>
              {{ $t("admin.views.orders.email") }}:
              <span>{{ order.email }}</span>
            </div>
            <div v-if="order.shipping_info">
              {{ $t("admin.views.orders.shipping_info") }}:<br />
              <span class="text-xs">{{ order.shipping_info }}</span>
            </div>
            <div>
              {{ $t("admin.views.orders.comment") }}:<br />
              <span class="text-xs">{{ order.comment }}</span>
            </div>
          </div>
          <div class="mb-8">
            <div class="font-bold mb-2">
              {{ $t("admin.views.orders.summ") }}:
            </div>
            <div class="text-6xl">
              {{
                                $toCurrency(
                                    order.total_with_sale
                                        ? order.total_with_sale
                                        : order.total
                                )
                            }}
            </div>
          </div>
          <div
            class="order-prepaid-cost mb-8 flex gap-24"
            v-if="settings.calc_cost_price=='1'||settings.prepaid=='1'"
          >
            <div
              class="order-prepaid"
              v-if="settings.prepaid=='1'"
            >
              <div class="order-prepaid-cost__title">{{ $t('main.title_prepaid') }}</div>
              <div class="order-prepaid-cost__value">{{ $toCurrency(order.prepaid) }}</div>
            </div>
            <div
              class="order-cost cost-value"
              v-if="settings.calc_cost_price=='1'"
            >
              <div class="order-prepaid-cost__title">{{ $t('main.title_cost') }}</div>
              <div class="order-prepaid-cost__value">{{ $toCurrency(order.total_cost) }}</div>
            </div>
          </div>

          <div
            class="mb-8 updated"
            v-if="order.updated"
          >
            <div class="updated__title">Конфигурация заказа была обновлена:</div>
            <div class="updated__content">{{order.updated_at}}</div>

          </div>
          <div class="mb-4 flex flex-col gap-4">
            <a
              :href="`/generate-pdf/${order.order_id}`"
              class="flex items-center"
            >
              <span
                class="icon-download-pdf"
                style="background-image: url('/images/icons/icon-pdf.svg')"
              ></span>
              <span class="ml-2 text-sm">{{
                                $t("admin.views.orders.download_pdf")
                            }}</span>
            </a>
            <a
              :href="`/generate-pdf/${order.order_id}?adv=1`"
              class="flex items-center cost-value"
              v-if="settings.calc_cost_price=='1'"
            >
              <span
                class="icon-download-pdf"
                style="background-image: url('/images/icons/adv-pdf-admin.svg')"
              ></span>
              <span class="ml-2 text-sm">{{
                                $t("admin.views.orders.download_pdf_adv")
                            }}</span>
            </a>
          </div>
          <div
            class="mb-12"
            v-if="
                            order.order_cache_id &&
                                parseInt(order.order_cache_id) > 0
                        "
          >
            <a
              :href="`/?order_cache=${order.order_cache_id}`"
              target="_blank"
              class="
                bg-blue-500
                text-white
                rounded
                py-2
                px-6
                text-sm
                inline-block
              "
            >{{ $t("admin.views.orders.view_conf") }}</a>
          </div>
          <div>
            <div class="font-bold mb-4">
              {{ $t("admin.views.orders.3d_mockup") }}:
            </div>
            <div class="
                flex
                justify-center
                items-center
                mb-4
              ">
              <img
                :src="order.mockup"
                loading="lazy"
                alt=""
              />
            </div>
            <div>
              <a
                :href="order.mockup"
                target="_blank"
                class="flex items-center"
              >
              <span class="block w-8"><img
                    class="object-cover"
                    src="/images/icons/icon-download.svg"
                    loading="lazy"
                    alt=""
                  /></span>
                <span class="ml-4">{{
                                    $t("admin.views.orders.download_mockup")
                                }}</span>
              </a>
            </div>
            <div
              class="mt-4"
              v-if="order.order_faces.length"
            >
              <div class="font-bold mb-2">
                {{ $t("admin.views.orders.decor") }}
              </div>
              <div class="order-faces-list">
                <div
                  class="order-faces-item-wrapper"
                  v-for="(face, index) in order.order_faces"
                  :key="`faces-mock-${face.order_face_id}`"
                >
                  <div
                    class="order-faces-item"
                    v-if="face.elements.length||face.texts.length"
                  >
                    <div
                      class="order-faces-name text-sm"
                      v-html="
                                            `<span>${index + 1}</span>${
                                                face.name
                                            }`
                                        "
                    ></div>

                    <button
                      class="order-faces-image mb-2"
                      @click="popupFace=face"
                    >
                      <img
                        :src="face.thumb"
                        loading="lazy"
                        alt=""
                      />
                    </button>

                    <a
                      :href="face.image"
                      target="_blank"
                      class="flex items-center"
                    >
                      <span class="block w-8"><img
                          class="object-cover"
                          src="/images/icons/icon-download.svg"
                          loading="lazy"
                          alt=""
                        /></span>
                      <span class="ml-4">{{
                                            $t("main.download")
                                        }}</span>
                    </a>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-1/2 pl-8 order-detail-total">
        <div class="order-detail">
          <div class="font-bold mb-4">
            {{ $t("admin.views.orders.detail") }}:
          </div>

          <div class="elements">
            <div
              class="element-item-list"
              v-if="
                                order.order_elements &&
                                    order.order_elements.length
                            "
            >
              <card-element-cart
                v-for="element in order.order_elements"
                :key="
                                    `complectation-element-${element.element_id}`
                                "
                :element="element"
                :settings="settings"
              />
            </div>

            <card-landscaping-order
              class="mb-4 border-blue-top"
              v-if="
                                order.order_landscaping &&
                                    order.order_landscaping.length
                            "
              :settings="settings"
              :landscapings="order.order_landscaping"
            ></card-landscaping-order>

            <div
              v-if="order.barrier"
              class="text-xl mb-4 border-blue-top element-item-list"
            >
              <card-barrier-cart
                :barrier="order.barrier"
                :settings="settings"
              />
            </div>

            <CardEngravingCart
              v-if="order.order_faces && order.order_faces.length"
              class="mb-4 border-blue-top"
              :faces="order.order_faces"
              :settings="settings"
              :isComplectation="false"
            />
          </div>

        </div>
        <div
          class="order-total"
          v-if="order.order_additional_works.length"
        >
          <div class="font-bold mb-4 flex justify-between">
            <div>{{ $t("admin.views.orders.services") }}</div>
            <div></div>
          </div>
          <div class="services">
            <div>
              <div
                class="services__item"
                v-for="aw in order.order_additional_works"
                :key="`ad-${aw.is}`"
              >
                <div class="flex justify-between">
                  <div class="service__title">
                    <span v-if="aw.type == 'install'">{{
                                                $t(
                                                    "admin.views.orders.install"
                                                )
                                            }}:</span>
                    {{ aw.name }}
                  </div>
                  <div class="service__total">
                    {{ $toCurrency(aw.price) }}
                  </div>
                </div>
                <div
                  class="flex justify-between text-sm"
                  v-if="
                                        aw.type == 'install' &&
                                            aw.additional_cost_install_elements
                                    "
                >
                  <span>{{
                                        $t(
                                            "admin.views.orders.add_cost_install"
                                        )
                                    }}</span>
                  <span>{{ $toCurrency(aw.additional_cost_install_elements) }}</span>
                </div>
              </div>
              <div
                class="services__item"
                v-if="
                                    order.barrier &&
                                        order.barrier.final_price_installation
                                "
              >
                <div class="flex justify-between text-sm">
                  <span>{{
                                        $t(
                                            "admin.views.orders.cost_install_barrier"
                                        )
                                    }}</span>
                  <span>{{ $toCurrency(order.barrier.final_price_installation) }}</span>
                </div>
              </div>
            </div>

            <div
              class="services__item flex justify-between"
              v-if="order.shipping"
            >
              <div class="service__title">
                {{ $t("admin.views.orders.delivery") }}
              </div>
              <div class="service__total"></div>
            </div>
            <div
              class="services__item flex justify-between"
              v-if="order.winter_storage"
            >
              <div class="service__title">
                {{ $t("admin.views.orders.winter_storage") }}
              </div>
              <div class="service__total"></div>
            </div>
          </div>
        </div>
        <div
          class="order-total mt-2"
          v-if="order.plot"
        >
          <div class="text-xl mb-4">
            {{ $t("main.plot") }}
          </div>
          <div>
            {{ order.plot.name }}
          </div>
        </div>

        <div
          class="order-total"
          v-if="order.sale"
        >
          <div class="flex justify-between">
            <div class="font-semibold">
              {{ $t("admin.views.orders.summ_without_sale") }}
            </div>
            <div>{{ $toCurrency(order.total) }}</div>
          </div>
          <div class="flex justify-between mt-3">
            <div class="font-semibold">
              {{ $t("admin.views.orders.sale") }}
            </div>
            <div>{{ $toCurrency(order.sale) }}</div>
          </div>
        </div>
        <div class="order-total flex justify-between">
          <div>
            <div class="mb-1">
              {{ $t("admin.views.orders.weight_main_elements") }}:
            </div>
            <div class="text-xl">{{ order.weight }}</div>
          </div>
          <div class="text-right">
            <div class="font-medium mb-2">
              {{ $t("admin.views.orders.order_total") }}:
            </div>
            <div class="font-medium text-3xl">
              {{
                                $toCurrency(
                                    order.total_with_sale
                                        ? order.total_with_sale
                                        : order.total
                                )
                            }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <ClientModal
      v-if="popupFace"
      @close-modal="popupFace = null"
      class="popupFace"
      propWidth="900"
      propHeight="900"
    >
      <template
        #header
        v-html="popupFace.name"
      ></template>

      <div
        class="order-face-popup-image"
        :style="{ backgroundImage: `url(${popupFace.image})` }"
      ></div>
    </ClientModal>

  </div>
</template>

<script>
import validationErrors from "../../../mixins/validationErrors";
import CardBarrierCart from "../../../components/General/CardBarrierCart.vue";
import CardElementCart from "../../../components/General/CardElementCart.vue";
import CardLandscapingCart from "../../../components/General/CardLandscapingCart.vue";
import CardEngravingCart from "../../../components/General/CardEngravingCart.vue";
import CardLandscapingOrder from "../../../components/General/CardLandscapingOrder.vue";
export default {
  name: "Detail",
  components: {
    CardElementCart,
    CardLandscapingCart,
    CardBarrierCart,
    CardEngravingCart,
    CardLandscapingOrder,
  },
  mixins: [validationErrors],
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      popupFace: null,
    };
  },
  methods: {},
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
  },
};
</script>

<style scoped>
.order-faces-list {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
}

.order-faces-name {
  margin-bottom: 0.5rem;
}
.order-faces-image {
  border: 1px solid #c0c4d1;
  background-color: #fff;
  padding: 0.25rem;
  display: flex;
  width: 100%;
  justify-content: center;
}

.updated {
  background-color: #c8efd1;
  color: #0e4c1c;
  padding: 10px;
  border-radius: 4px;
}
.updated__title {
  font-size: 14px;
}
.updated__content {
  font-size: 18px;
  font-weight: 600;
}
.order-face-popup-image {
  background-color: #fff;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 900px;
  width: 900px;
  margin: auto;
}
.order-prepaid-cost__value {
  font-size: 24px;
}
@media screen and (max-width: 1000px) {
  .order-face-popup-image {
    width: 94%;
    height: 90vh;
  }
}
</style>
